import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { separate } from "../../Functions/NumberSeprator";
import Style from "./ChangeProduct.module.css";

const ChangeProduct = ({
  searchValue,
  setChangeProduct,
  handleClose,
  rawInfo,
  setSearchValue,
}) => {
  const [productInput, setProductInput] = useState();
  const [productId, setProductId] = useState();
  const { register, handleSubmit } = useForm();

  const clickProductHandler = (item) => {
    setProductId(item.id);
    setSearchValue(false);
  };
  const onSubmit = (data) => {
    setChangeProduct(
      {
        product_id: productId,
        p_product_id: rawInfo.id,
        new_count: data.newCount,
        new_price: 0,
        availability: "1",
      }
    );
    handleClose();
  };
  console.log(productInput)
  return (
    <div className={Style.modalHolder}>
      <input
        className={Style.search}
        placeholder="جستجو محصولات موجود در انبارتان"
        onChange={(e) => setProductInput(e.target.value)}
        value={productInput}
        autoComplete={"off"}
      />
      {/* *********************search result ******************* */}
      {productInput!==undefined && productInput!==""?(
        <ul className={Style.searchResult}>
          {searchValue&&searchValue
            .filter((value) => {
              if (value.name.includes(productInput)) {
                return value;
              } else {
                return null;
              }
            })
            .map((item, index) => {
              return (
                <li
                  onClick={() => clickProductHandler(item)}
                  className={Style.resultItem}
                  key={index}
                >
                  <div className={Style.imgHolder}>
                    <img
                      src={`https://cdn.barest.ir/product/m/${item.id}.jpg`}
                      alt=""
                    />
                  </div>
                  <div className={Style.infoPart}>
                    <h3 className={Style.nameproduct}>{item.name}</h3>
                    <h3 className={Style.priceProduct}>
                      {separate(item.price)} تومان
                    </h3>
                  </div>
                </li>
              );
            })}
        </ul>
      ):null}

      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className={Style.formPart}>
        <input
          {...register("newCount")}
          className={Style.count}
          placeholder="تعداد محصول جدید"
        />
        <button className={Style.addBtn}>افزودن</button>
      </form>
    </div>
  );
};

export default ChangeProduct;
